define('widgets/languageSelector/viewmodel',[
    'knockout',
    'underscore'
    ], function (ko, _) {

        function LanguageSelector(i18n, navigation, settings) {
            var self = this;

            this.availableMarkets = i18n.availableMarkets;
            this.settings = settings;
            this.selectedMarket = settings.selectedMarket;

            this.getMarketUrl = function (market) {
                return navigation.currentPathForMarket(market, true);
            };
        }

        LanguageSelector.prototype.selectMarket = function (market) {
            this.settings.selectMarket(market);
        };

        return LanguageSelector;
    }
);

